<mat-toolbar class="navbar">

    <mat-toolbar-row class="row">

        <mat-icon class="item icon-only interactable" matTooltip="Zur Startseite" (click)="gotoStartpage()" routerLinkActive="active">home</mat-icon>

        <mat-icon @show *ngIf="(sessionService.loggedIn$|async) && (navbarView == 0 || navbarView == 1)"
            class="item icon-only small interactable navigation" matTooltip="Zurück" (click)="previous()">arrow_back
        </mat-icon>

        <mat-icon @show *ngIf="(sessionService.loggedIn$|async) && (navbarView == 0 || navbarView == 1)"
            class="item icon-only small interactable navigation" matTooltip="Vorwärts" (click)="next()">arrow_forward
        </mat-icon>

        <mat-icon @show *ngIf="(sessionService.loggedIn$|async) && (navbarView == 1 || navbarView == 2)"
            class="item icon-only small interactable navigation" matTooltip="Navigation"
            [matMenuTriggerFor]="optionsMenu">more_horiz</mat-icon>

        <span @show *ngIf="(sessionService.loggedIn$|async) && navbarView == 0 && rightsMap.use_report_system" class="item text-only"
            matTooltip="Reports erzeugen" [matMenuTriggerFor]="reportsMenu">Auswertungen</span>

        <span @show *ngIf="(sessionService.loggedIn$|async) && navbarView == 0 && rightsMap.customer_navbar_option" id="navbar-customer-trigger"
            class="item text-only" matTooltip="Kundenbezogene Funktionen"
            [matMenuTriggerFor]="customerMenu">Kunden</span>

        <span @show *ngIf="(sessionService.loggedIn$|async) && navbarView == 0 && rightsMap.issue_navbar_option" id="navbar-issue-trigger" class="item text-only"
            matTooltip="Vorgangsbezogene Funktionen" [matMenuTriggerFor]="issueMenu">Vorgänge</span>

        <span @show *ngIf="(sessionService.loggedIn$|async) && navbarView == 0 && rightsMap.edit_datasets" class="item text-only"
            matTooltip="Administrative Funktionen" [matMenuTriggerFor]="adminMenu">Administration</span>

        <span @show *ngIf="(sessionService.loggedIn$|async) && navbarView == 0 && rightsMap.location_navbar_option" class="item text-only"
            matTooltip="Standortbezogene Funktionen" [matMenuTriggerFor]="locationMenu">Standorte</span>

            <span @show *ngIf="(sessionService.loggedIn$|async) && navbarView == 0 && rightsMap.customer_navbar_option" id="navbar-customer-trigger"
            class="item text-only" matTooltip="Kundenbezogene Funktionen"
            [matMenuTriggerFor]="documentationMenu">Dokumentation</span>

        <span @show style="display: none" class="item text-only"
            matTooltip="Zum Produktshop" routerLink="/shop" routerLinkActive="active">Shop</span>

        <span style="flex: 1;"></span>

        <div class="auto-logout-wrapper" (click)="tryToggleAutoLogout()">

            <div class="title">Logout in</div>
            <div class="time" [class.disabled]="sessionService.autoLogoutDisabled">
                {{sessionService.autoLogoutDisabled? 'INAKTIV': (sessionService.autoLogoutSeconds$|async|secondsLeft)}}
            </div>

        </div>

        <div class="right-icon-container" *ngIf="(sessionService.loggedIn$|async)">
            <div *ngIf="false" class="notification-wrapper" matTooltip="Benachrichtigungen" (click)="showNotifications()">
                <span class="inline-counter">
                    {{notificationCounter}}
                </span>
                <mat-icon class="item icon-only right-icon">
                    notifications_none
                </mat-icon>
            </div>
            <mat-icon class="item icon-only right-icon" matTooltip="AMS Assistent" (click)="openQuickAssist()">
                adb
            </mat-icon>
            <mat-icon style="display: none;" class="item icon-only right-icon" matTooltip="Chat">
                chat_bubble_outline
            </mat-icon>
            <mat-icon class="item icon-only right-icon" matTooltip="Einstellungen" *ngIf="rightsMap.update_own_settings"
                (click)="navigateToGeneralSetting()">
                miscellaneous_services
            </mat-icon>
            <mat-icon class="item icon-only right-icon logout" id="logout" matTooltip="Ausloggen" (click)="logout()">
                power_settings_new</mat-icon>
        </div>

        <div @show *ngIf="(sessionService.loggedIn$|async)" class="user-wrapper" (click)="navigateToGeneralSetting()">
            <div *ngIf="!hasProfilePicture; else profilePicture" class="username-wrapper">{{username}}</div>
            <ng-template #profilePicture>
                <img src={{profilePictureData}} class="user-image" />
            </ng-template>
            <div class="websocket-state" [style.background]="socketState.color" matTooltip="{{socketState.tooltip}}">
            </div>
        </div>

    </mat-toolbar-row>

</mat-toolbar>

<div class="loader" [style.height.px]="loaderDisplayHeight">
    <div class="loader-thumb" [style.width.%]="progress"></div>
</div>

<mat-menu #reportsMenu="matMenu">
    <button mat-menu-item class="dropdown-item"  routerLink="/report" routerLinkActive="active">
        <mat-icon class="dropdown-icon">adb</mat-icon>
        <span>AMS Reporting Tool</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="navigateToAllStocks()">
        <mat-icon class="dropdown-icon">assignment</mat-icon>
        <span>Alle Bestände</span>
        <span class="sub-title">Alle Bestände anzeigen</span>
    </button>
    <mat-divider class="divider"></mat-divider>
    <button mat-menu-item class="dropdown-item" (click)="navigateToWistaIncrease()">
        <mat-icon class="dropdown-icon">trending_up</mat-icon>
        <span>Wista-Mehrungen</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="navigateToWistaDecrease()">
        <mat-icon class="dropdown-icon">trending_down</mat-icon>
        <span>Wista-Minderungen</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="navigateToWistaServiceReview()">
        <mat-icon class="dropdown-icon">build</mat-icon>
        <span>Wista-Servicereview</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="navigateToWistaTicketReview()">
        <mat-icon class="dropdown-icon">flash_on</mat-icon>
        <span>Wista-Ticketübersicht</span>
    </button>
    <mat-divider class="divider"></mat-divider>
    <button mat-menu-item class="dropdown-item" (click)="navigateToSonyIncrease()">
        <mat-icon class="dropdown-icon">trending_up</mat-icon>
        <span>Sony-Mehrungen</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="navigateToSonyDecrease()">
        <mat-icon class="dropdown-icon">trending_down</mat-icon>
        <span>Sony-Minderungen</span>
    </button>
    <mat-divider class="divider"></mat-divider>
    <button mat-menu-item (click)="openStockList()" class="dropdown-item">
        <span class="dropdown-placeholder"></span>
        <span>Lagerliste öffnen</span>
    </button>
</mat-menu>

<mat-menu #customerMenu="matMenu">
    <button style="display: none;" mat-menu-item class="dropdown-item" disabled>
        <mat-icon class="dropdown-icon">domain</mat-icon>
        <span>Kunden</span>
        <span class="sub-title">Wechselt zur Kundenseite</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="quickCreateCustomer()">
        <span class="dropdown-placeholder"></span>
        <span>Neuen Kunden anlegen</span>
    </button>
    <button id="navbar-edit-customer-trigger" mat-menu-item class="dropdown-item" (click)="selectCustomerForEdit()">
        <mat-icon class="dropdown-icon">domain</mat-icon>
        <span>Kunde bearbeiten</span>
    </button>
    <mat-divider class="divider"></mat-divider>
    <button mat-menu-item class="dropdown-item" (click)="quickCreateContract()">
        <span class="dropdown-placeholder"></span>
        <span>Neuen Vertrag anlegen</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="selectContractForEdit()">
        <span class="dropdown-placeholder"></span>
        <span>Vertrag bearbeiten</span>
    </button>
    <mat-divider class="divider"></mat-divider>
    <button mat-menu-item class="dropdown-item" (click)="quickCreateContactperson()">
        <mat-icon class="dropdown-icon">supervisor_account</mat-icon>
        <span>Neuen Ansprechpartner anlegen</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="selectContactpersonForEdit()">
        <span class="dropdown-placeholder"></span>
        <span>Ansprechpartner bearbeiten</span>
    </button>
</mat-menu>

<mat-menu #issueMenu="matMenu">
    <button style="display: none;" mat-menu-item class="dropdown-item" disabled>
        <mat-icon class="dropdown-icon">assessment</mat-icon>
        <span>Vorgänge</span>
        <span class="sub-title">Wechselt zur Vorgangsseite</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="executeCreateIssueTransaction()">
        <mat-icon class="dropdown-icon">assessment</mat-icon>
        <span>Neuen Vorgang anlegen</span>
    </button>
    <button id="navbar-edit-issue-trigger" mat-menu-item (click)="selectIssueForEdit()" class="dropdown-item">
        <span class="dropdown-placeholder"></span>
        <span>{{rightsMap.update_issues? 'Vorgang bearbeiten': 'Vorgang ansehen'}}</span>
    </button>
    <button *ngIf="rightsMap.overwrite_control_slip" mat-menu-item (click)="selectIssueToOverwriteControlSlip()"
        class="dropdown-item">
        <span class="dropdown-placeholder"></span>
        <span>Standardlaufzettel überschreiben</span>
    </button>
    <button mat-menu-item class="dropdown-item" routerLink="/mail-inbox/assignment" routerLinkActive="active">
        <span class="dropdown-placeholder"></span>
        <span>Auftragseingang einsehen</span>
    </button>
    <button style="display: none;" mat-menu-item class="dropdown-item" disabled>
        <mat-icon class="dropdown-icon">euro_symbol</mat-icon>
        <span>Angebote verwalten</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="addOffer()">
        <mat-icon class="dropdown-icon">euro_symbol</mat-icon>
        <span>Neues Angebot anlegen</span>
    </button>
    <button mat-menu-item (click)="selectOfferForEdit()" class="dropdown-item">
        <span class="dropdown-placeholder"></span>
        <span>Angebot bearbeiten</span>
    </button>
    <mat-divider class="divider"></mat-divider>
    <button style="display: none;" mat-menu-item class="dropdown-item" disabled>
        <mat-icon class="dropdown-icon">flash_on</mat-icon>
        <span>Incidents</span>
        <span class="sub-title">Wechselt zur Ticketseite</span>
    </button>
    <button id="navbar-create-incident-trigger" mat-menu-item class="dropdown-item" (click)="exectueCreateIncidentTransaction()">
        <mat-icon class="dropdown-icon">play_arrow</mat-icon>
        <span>Neues Ticket anlegen</span>
    </button>
    <button mat-menu-item (click)="selectIncidentForEdit()" class="dropdown-item">
        <span class="dropdown-placeholder"></span>
        <span>Ticket bearbeiten</span>
    </button>
    <button mat-menu-item class="dropdown-item" routerLink="/mail-inbox/incident" routerLinkActive="active">
        <span class="dropdown-placeholder"></span>
        <span>Ticketeingang einsehen</span>
    </button>
    <mat-divider class="divider"></mat-divider>
    <button style="display: none;" mat-menu-item class="dropdown-item" disabled>
        <mat-icon class="dropdown-icon">style</mat-icon>
        <span>Changes (RFCs)</span>
        <span class="sub-title">Wechselt zur Changeseite</span>
    </button>
    <button mat-menu-item class="dropdown-item" routerLink="/add-change" routerLinkActive="active">
        <mat-icon class="dropdown-icon">style</mat-icon>
        <span>Neuen Change anlegen</span>
    </button>
    <button mat-menu-item (click)="selectChangeForEdit()" class="dropdown-item">
        <span class="dropdown-placeholder"></span>
        <span>Change bearbeiten</span>
    </button>
    <mat-divider class="divider"></mat-divider>
    <button style="display: none;" mat-menu-item class="dropdown-item" disabled>
        <mat-icon class="dropdown-icon">receipt</mat-icon>
        <span>Projekte</span>
        <span class="sub-title">Wechselt zur Projektseite</span>
    </button>
    <button [disabled]="true" mat-menu-item class="dropdown-item">
        <mat-icon class="dropdown-icon">receipt</mat-icon>
        <span>Neues Projekt anlegen</span>
    </button>
    <button [disabled]="true" mat-menu-item class="dropdown-item">
        <span class="dropdown-placeholder"></span>
        <span>Projekt bearbeiten</span>
    </button>
</mat-menu>

<mat-menu #adminMenu="matMenu">
    <button mat-menu-item class="dropdown-item" routerLink="/users" routerLinkActive="active">
        <mat-icon class="dropdown-icon">person</mat-icon>
        <span>Benutzer verwalten</span>
        <span class="sub-title">Verwalten Sie alle Accounts</span>
    </button>
    <button mat-menu-item class="dropdown-item" routerLink="/roles" routerLinkActive="active">
        <mat-icon class="dropdown-icon">supervised_user_circle</mat-icon>
        <span>Rollen verwalten</span>
        <span class="sub-title">Verwalten Sie alle Rollen</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="selectUserAndEditDashboard()">
        <span class="dropdown-placeholder"></span>
        <span>Fremdes Dashboard anpassen</span>
    </button>
    <button mat-menu-item class="dropdown-item" routerLink="/access-denied-log" routerLinkActive="active">
        <mat-icon class="dropdown-icon">voice_over_off</mat-icon>
        <span>Berechtigungsfehler</span>
        <span class="sub-title">HTTP 403</span>
    </button>
    <button mat-menu-item class="dropdown-item" routerLink="/nextclouddiagnose" routerLinkActive="active">
        <span class="dropdown-placeholder"></span>
        <span>Diagnose Nextcloud Logins</span>
    </button>
    <mat-divider class="divider"></mat-divider>
    <button mat-menu-item class="dropdown-item" routerLink="/templates" routerLinkActive="active">
        <span class="dropdown-placeholder"></span>
        <span>Standardtexte editieren</span>
    </button>
    <mat-divider class="divider"></mat-divider>
    <button mat-menu-item class="dropdown-item" routerLink="/issue-transactions" routerLinkActive="active">
        <mat-icon class="dropdown-icon">transform</mat-icon>
        <span>Vorgangstransaktionen anpassen</span>
    </button>
    <mat-divider class="divider"></mat-divider>
    <button mat-menu-item class="dropdown-item" (click)="navigateToDocumentation()">
        <span class="dropdown-placeholder"></span>
        <span>API Dokumentation</span>
    </button>
    <button mat-menu-item class="dropdown-item" routerLink="/product-management" routerLinkActive="active">
        <mat-icon class="dropdown-icon">router</mat-icon>
        <span>Produkte verwalten</span>
    </button>
</mat-menu>

<mat-menu #locationMenu="matMenu">
    <button mat-menu-item class="dropdown-item" (click)="quickCreateLocation()" routerLinkActive="active">
        <mat-icon class="dropdown-icon">add_location_alt</mat-icon>
        <span>Neuen Standort anlegen</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="selectLocationForEdit()">
        <mat-icon class="dropdown-icon">location_on</mat-icon>
        <span>Standort bearbeiten</span>
    </button>
</mat-menu>

<mat-menu #documentationMenu="matMenu">
    <button mat-menu-item class="dropdown-item" (click)="navigateToProcessDoc()">
        <mat-icon class="dropdown-icon">assignment</mat-icon>
        <span>Prozessdokumentation</span>
        <span class="sub-title">zur Prozessdokumentation</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="navigateToAdminDoc()">
        <mat-icon class="dropdown-icon">style</mat-icon>
        <span>Betriebsdokumentation</span>
        <span class="sub-title">zur Betriebsdokumentation</span>
    </button>
    <mat-divider class="divider"></mat-divider>
    <mat-divider class="divider"></mat-divider>
    <button mat-menu-item (click)="openStockList()" class="dropdown-item">
        <span class="dropdown-placeholder"></span>
        <span>Lagerliste öffnen</span>
    </button>
</mat-menu>

<mat-menu #optionsMenu="matMenu">
    <button *ngIf="(sessionService.loggedIn$|async) && (navbarView == 1 || navbarView == 2) && rightsMap.use_report_system" mat-menu-item
        class="dropdown-item nested" [matMenuTriggerFor]="reportsMenu">
        <mat-icon class="dropdown-icon">show_chart</mat-icon>
        <span>Auswertungen</span>
    </button>
    <button *ngIf="(sessionService.loggedIn$|async) && (navbarView == 1 || navbarView == 2) && rightsMap.customer_navbar_option" mat-menu-item
        class="dropdown-item nested" [matMenuTriggerFor]="customerMenu">
        <mat-icon class="dropdown-icon">domain</mat-icon>
        <span>Kunden</span>
    </button>
    <button *ngIf="(sessionService.loggedIn$|async) && (navbarView == 1 || navbarView == 2) && rightsMap.issue_navbar_option" mat-menu-item
        class="dropdown-item nested" [matMenuTriggerFor]="issueMenu">
        <mat-icon class="dropdown-icon">assessment</mat-icon>
        <span>Vorgänge</span>
    </button>
    <button *ngIf="(sessionService.loggedIn$|async) && (navbarView == 1 || navbarView == 2) && rightsMap.edit_datasets" mat-menu-item
        class="dropdown-item nested" [matMenuTriggerFor]="adminMenu">
        <mat-icon class="dropdown-icon">security</mat-icon>
        <span>Administration</span>
    </button>
    <button *ngIf="(sessionService.loggedIn$|async) && (navbarView == 1 || navbarView == 2) && rightsMap.location_navbar_option" mat-menu-item
        class="dropdown-item nested" [matMenuTriggerFor]="locationMenu">
        <mat-icon class="dropdown-icon">location_on</mat-icon>
        <span>Standorte</span>
    </button>
    <button *ngIf="(sessionService.loggedIn$|async) && (navbarView == 1 || navbarView == 2) && rightsMap.customer_navbar_option" mat-menu-item
        class="dropdown-item nested" [matMenuTriggerFor]="documentationMenu">
        <mat-icon class="dropdown-icon">documentation</mat-icon>
        <span>Dokumentation</span>
    </button>
</mat-menu>